/**
 * Workflows — Saved multi-agent playbooks. MOCKED.
 */
import MarketingShell from "@/components/MarketingShell";
import { Workflow as WorkflowIcon, Play, Plus, Calendar, Webhook, Zap, ChevronRight } from "lucide-react";

const BUILT_IN = [
  { id: "wf-launch", name: "New product feature launch", trigger: "manual", steps: 7, useCount: 0, summary: "Audience → Content Agent (6 variants) → SEO/GEO schema → Brand check → Approvals → Social/Email scheduling → Analyst watch." },
  { id: "wf-webinar", name: "Webinar promotion", trigger: "manual", steps: 5, useCount: 0, summary: "Three weeks of EventPromo touchpoints across Story / Square / Wide. Email sequence + reminder + post-event recap." },
  { id: "wf-case-study", name: "Case study amplification", trigger: "manual", steps: 6, useCount: 0, summary: "Generates Testimonial + Stat/Proof social variants, email to right segment, G2 review pitch (when wired)." },
  { id: "wf-content-gap", name: "Competitive content gap response", trigger: "event", steps: 4, useCount: 0, summary: "Triggered when SEO/GEO Engine detects share-of-answer drop. Auto-drafts brief, queues for editorial review." },
  { id: "wf-quarterly", name: "Quarterly review writeup", trigger: "scheduled", steps: 3, useCount: 0, summary: "Analyst Agent gathers metrics, drafts narrative report, builds slide deck, sends digest to leadership." },
];

const CUSTOM = [];

const TRIGGER_ICON = { manual: Play, scheduled: Calendar, event: Zap, webhook: Webhook };

export default function Workflows() {
  return (
    <MarketingShell
      title="Workflows"
      subtitle="Saved multi-agent playbooks — go from intent to multi-channel campaign in one click"
      actions={<button className="btn btn-primary"><Plus style={{ width: 13, height: 13 }} /> New workflow</button>}
    >
      <div data-testid="workflows-page">
        <h3 className="card-title" style={{ marginBottom: 12 }}>Built-in playbooks</h3>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 12, marginBottom: 28 }}>
          {BUILT_IN.map((w) => {
            const TIcon = TRIGGER_ICON[w.trigger] || Play;
            return (
              <div key={w.id} className="mkt-card is-interactive" style={{ padding: "16px 18px", cursor: "pointer" }} data-testid={`workflow-${w.id}`}>
                <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
                  <WorkflowIcon style={{ width: 16, height: 16, color: "var(--blue)" }} />
                  <h4 style={{ fontFamily: "var(--font-head)", fontSize: 13.5, fontWeight: 600, color: "var(--navy)", flex: 1 }}>{w.name}</h4>
                  <span className="tag tag-blue" style={{ display: "inline-flex", alignItems: "center", gap: 3 }}>
                    <TIcon style={{ width: 10, height: 10 }} /> {w.trigger}
                  </span>
                </div>
                <p style={{ fontSize: 12, color: "var(--text-secondary)", lineHeight: 1.55, marginBottom: 12 }}>{w.summary}</p>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: 10.5, color: "var(--text-tertiary)" }}>
                  <span><strong className="num" style={{ color: "var(--text-secondary)" }}>{w.steps}</strong> steps · used <strong className="num" style={{ color: "var(--text-secondary)" }}>{w.useCount}</strong>×</span>
                  <button className="btn btn-primary" style={{ height: 26, padding: "0 10px", fontSize: 11 }}>
                    Run <ChevronRight style={{ width: 12, height: 12 }} />
                  </button>
                </div>
              </div>
            );
          })}
        </div>

        <h3 className="card-title" style={{ marginBottom: 12 }}>Your workflows</h3>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 12 }}>
          {CUSTOM.map((w) => {
            const TIcon = TRIGGER_ICON[w.trigger] || Play;
            return (
              <div key={w.id} className="mkt-card is-interactive" style={{ padding: "16px 18px" }} data-testid={`workflow-${w.id}`}>
                <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
                  <WorkflowIcon style={{ width: 16, height: 16, color: "var(--purple)" }} />
                  <h4 style={{ fontFamily: "var(--font-head)", fontSize: 13.5, fontWeight: 600, color: "var(--navy)", flex: 1 }}>{w.name}</h4>
                  <span className="tag tag-purple" style={{ display: "inline-flex", alignItems: "center", gap: 3 }}>
                    <TIcon style={{ width: 10, height: 10 }} /> {w.trigger}
                  </span>
                </div>
                <p style={{ fontSize: 12, color: "var(--text-secondary)", lineHeight: 1.55, marginBottom: 12 }}>{w.summary}</p>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: 10.5, color: "var(--text-tertiary)" }}>
                  <span><strong className="num" style={{ color: "var(--text-secondary)" }}>{w.steps}</strong> steps · used <strong className="num" style={{ color: "var(--text-secondary)" }}>{w.useCount}</strong>×</span>
                  <button className="btn btn-primary" style={{ height: 26, padding: "0 10px", fontSize: 11 }}>
                    Run <ChevronRight style={{ width: 12, height: 12 }} />
                  </button>
                </div>
              </div>
            );
          })}
          <div className="mkt-card" style={{ padding: "16px 18px", display: "flex", alignItems: "center", justifyContent: "center", borderStyle: "dashed", color: "var(--text-tertiary)", cursor: "pointer" }}>
            <Plus style={{ width: 14, height: 14, marginRight: 6 }} /> Build a custom workflow
          </div>
        </div>
      </div>
    </MarketingShell>
  );
}
